var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { YearTemplate } from '@/models/YearTemplate';
import ErrorHandler from '@/support/ErrorHandler';
import { Component, Vue } from 'vue-property-decorator';
let CreateDialog = class CreateDialog extends Vue {
    constructor() {
        super(...arguments);
        this.yearTemplate = new YearTemplate({
            name: '',
            year_name: '',
            starts_at: '',
            ends_at: '',
            periods: [],
        });
        this.isLoading = false;
        this.currentStep = 1;
    }
    close() {
        this.$emit('input', false);
    }
    get isValid() {
        return !!(this.yearTemplate.name &&
            this.yearTemplate.year_name &&
            this.yearTemplate.starts_at &&
            this.yearTemplate.ends_at);
    }
    async create() {
        if (!this.isValid)
            return;
        this.isLoading = true;
        this.currentStep = 3;
        try {
            await this.yearTemplate.create();
            this.$emit('created');
        }
        catch (error) {
            ErrorHandler.network(error);
            this.currentStep = 1;
        }
        finally {
            this.isLoading = false;
        }
    }
};
CreateDialog = __decorate([
    Component({})
], CreateDialog);
export default CreateDialog;
